import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { employeeManagedEmployees } from 'modules/employees/store/collections/employeesContractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import {
  employeeLocation,
  managedEmployeesLocations,
} from 'modules/locations/store/collections/locations'
import type DefaultShift from 'modules/shift_management/store/internal/models/DefaultShift'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'
import { peopleLedByEmployeeLocations } from 'modules/teams/store/peopleLedByEmployeeLocations'

export const getVisibleDefaultShifts = (
  employee: Employee,
  activeDefaultShifts: DefaultShift[],
  contractVersions: ContractVersions
): DefaultShift[] => {
  const visibleTeams = employeeTeams(teams, memberships, employee.id)
  const visibleTeamsIds = new Set(visibleTeams.map((team) => team.id))

  const locationsToConsider = new Set([
    ...managedEmployeesLocations(
      employee.attributes.location_id,
      employeeManagedEmployees(employee, contractVersions)
    ),
    ...peopleLedByEmployeeLocations(teams, memberships, employee, contractVersions),
  ])

  const location = employeeLocation(employee.attributes.location_id)

  if (location) {
    locationsToConsider.add(location)
  }

  const visibleLocations = Array.from(locationsToConsider)
  const visibleLocationIds = new Set(visibleLocations.map((visibleLocation) => visibleLocation.id))

  const shiftsForAllCompanies = activeDefaultShifts.filter((shift) => {
    return shift.allCompany
  })

  const shiftsByTeams = activeDefaultShifts.filter((shift) => {
    return shift.teamsIdsVisibilities?.some((id) => visibleTeamsIds.has(id))
  })

  const shiftsByLocations = activeDefaultShifts.filter((shift) => {
    return shift.locationsIdsVisibilities?.some((id) => visibleLocationIds.has(id))
  })

  const finalShifts = new Set([...shiftsForAllCompanies, ...shiftsByTeams, ...shiftsByLocations])
  const sortedShifts = Array.from(finalShifts).sort((a, b) => a.title.localeCompare(b.title))

  return sortedShifts
}
